<template>
  <div class="text-center">
    <v-overlay :opacity="0.46" style="z-index: 999999999">
      <v-card
        @click="welcome = false"
        class="pa-3 rounded-20"
        color="white"
        width="600"
      >
        <v-card-title
          style="font-size: 24px"
          class="title-font primary--text font-weight-bold"
        >
          PROCESSING...
        </v-card-title>
        <v-card-text
          class="black--text font-weight-medium text-left"
          style="font-size: 16px"
        >
          Preparing your account, please wait a few moments...
        </v-card-text>
        <v-responsive
          class="mx-5 mb-3 d-flex align-center"
          style="height: 310px"
        >
          <LoadingSpinner />
        </v-responsive>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import client from "@/lib/ApiClient"
import { delay } from "@/utils"

export default {
  name: "ActivationPage",

  computed: {
    ...mapGetters(["activeSubscription"])
  },

  methods: {
    ...mapActions(["setSubscription", "triggerReload"]),

    async poll() {
      await delay(500)
      const subscriptionResponse =
        await client.gateway.billing.subscriptionInformation()
      if (
        subscriptionResponse?.subscription_status === "active" &&
        subscriptionResponse?.end_time
      ) {
        this.setSubscription(subscriptionResponse)
        this.triggerReload("quotas")
        this.$router.push({ name: "inboxPage", params: { welcome: true } })
      } else this.poll()
    }
  },

  mounted() {
    if (this.activeSubscription)
      this.$router.push({ name: "inboxPage", params: { welcome: true } })
    else this.poll()
  }
}
</script>
